<template>
  <div class="antialiased bg-black text-white font-sans">
    <div class="container mx-auto px-6 py-24 md:py-32">
      
      <section class="max-w-4xl">
        <h1 class="text-4xl sm:text-5xl md:text-6xl font-light tracking-tight">
          Tecnologia inteligente<br />
          para quem vive de delivery.
        </h1>
        <p class="mt-4 text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight">
          <span class="bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 bg-clip-text text-transparent">
            Parceria para quem quer ir além.
          </span>
        </p>
        <p class="mt-8 max-w-xl text-lg text-gray-300 leading-relaxed">
          Na Overx, entendemos os desafios da alimentação moderna. Por isso, criamos uma plataforma que faz muito mais do que organizar pedidos — ela conecta, simplifica e acelera o seu negócio.
        </p>
      </section>

      <div class="my-24 md:my-32"></div>

      <div class="flex justify-end">
        <section class="max-w-3xl">
          <h2 class="text-4xl sm:text-5xl font-bold tracking-tight">
            A Nossa 
           <span class="bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 bg-clip-text text-transparent">Essência</span>
          </h2>
          <div class="mt-10 space-y-7 text-lg md:text-xl text-gray-300 leading-relaxed">
            <p>
              Se você está no comando de uma operação de food service, sabe que não basta vender bem — é preciso entregar com eficiência, coordenar múltiplos canais e manter a equipe em sintonia.
            </p>
            <p>
              Foi justamente para isso que criamos a <strong class="font-bold text-white">Overx:</strong> uma solução completa para gerenciar e expandir suas operações de delivery com agilidade, controle e inteligência.
            </p>
            <p>
              Acreditamos em tecnologia simples, que funciona de verdade, e em parceria próxima, com suporte humano, segurança e evolução contínua.
            </p>
            <p class="font-bold text-orange-400 text-xl md:text-2xl">
              Estamos lado a lado com você, em cada pedido, em cada etapa.
            </p>
          </div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketingSectionAligned',
}
</script>

<style scoped>
.bg-clip-text {
  -webkit-background-clip: text;
  background-clip: text;
}
</style>